import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { Form } from '../../../../../../../../../form-elements/Form';
import { LabeledInput } from '../../../../../../../../../form-elements/inputs/LabeledInput';
import { Grid } from '../../../../../../../../../layout/Grid';
import { Brikk } from '../../../../../../../../../Brikk';
// eslint-disable-next-line import/no-cycle
import { UserAdministrationModalContext } from '../../../../index';
import styles from '../../../../styles.module.scss';
import { useInviteUser } from '../../../../../../../../../../services/admin/invite-user';
import { adminUserSchema } from '../../../../../../../../../../utils/validation/schemas';

export const AddUserForm = () => {
  const { setIsAddingUser } = useContext(UserAdministrationModalContext);

  const { inviteUser, isLoading } = useInviteUser({
    onSuccess: () => {
      setIsAddingUser(false);
    },
  });

  const {
    control,
    handleSubmit,
    formState: { isDirty, errors },
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(adminUserSchema),
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
    },
  });

  const onSubmit = (data) => {
    inviteUser({
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
    });
  };

  return (
    <>
      <Brikk.Heading
        heading="addNewUser"
      />

      <Grid
        noPadding
        oneColumn
      >
        <Form
          className={styles.form}
          onSubmit={handleSubmit(onSubmit)}
        >
          <div
            className={styles.equalColumns}
          >
            <Controller
              name="firstName"
              control={control}
              render={({ field: { ref, onChange, value } }) => (
                <LabeledInput
                  labelIntl="firstName"
                  id="first-name"
                  value={value}
                  inputRef={ref}
                  onChange={onChange}
                  hasError={!!errors.firstName}
                />
              )}
            />

            <Controller
              name="lastName"
              control={control}
              render={({ field: { ref, onChange, value } }) => (
                <LabeledInput
                  labelIntl="lastName"
                  id="family-name"
                  value={value}
                  inputRef={ref}
                  onChange={onChange}
                  hasError={!!errors.lastName}
                />
              )}
            />
          </div>

          <Controller
            name="email"
            control={control}
            render={({ field: { ref, onChange, value } }) => (
              <LabeledInput
                labelIntl="email"
                id="email"
                type="email"
                value={value}
                inputRef={ref}
                onChange={onChange}
                hasError={!!errors.email}
              />
            )}
          />

          <Controller
            name="phone"
            control={control}
            render={({ field: { ref, onChange, value } }) => (
              <LabeledInput
                labelIntl="phoneNumber"
                id="phoneNumber"
                value={value}
                inputRef={ref}
                onChange={onChange}
                hasError={!!errors.phone}
              />
            )}
          />

          <div className={styles.formButtons}>
            <Button
              basic
              name="cancel-add-user"
              disabled={isLoading}
              onClick={() => setIsAddingUser(false)}
            >
              <FormattedMessage id="cancel" />
            </Button>
            <Button
              primary
              type="submit"
              name="submit-add-user"
              disabled={!isDirty || isLoading}
              loading={isLoading}
            >
              <FormattedMessage id="addUser" />
            </Button>
          </div>
        </Form>
      </Grid>
    </>
  );
};
